import Api from '../api'
import { AxiosResponse} from "axios";
import DynamicObject from "../../models/dynamic-object";

export default (flow:number, config?: DynamicObject): Promise<AxiosResponse> => {
    const path = `bundle-user/services?flow=${flow}`;
    return Api.getInstance().request.get(path, `bundle-user/services`)
}

